import React from 'react';
import { Folders } from './Folders';

const AdminFolders: React.FC = () => <Folders action="administration" />;

export default AdminFolders;
